/**
 * The legion-ui version the site documents.
 *
 * Vite inlines this at build time from the actually-installed package, so the
 * badge cannot drift from what the examples are running against. Importing
 * the package's package.json directly would work in dev and break the build,
 * since it is not in the package's `exports` map.
 */
declare const __LEGION_UI_VERSION__: string

export const LEGION_UI_VERSION = __LEGION_UI_VERSION__
